const autoNgTemplateLoaderTemplate1 = require('./stats.html');

angular.module('shbdeployer.kubernetes').component('kubernetesApplicationStatsView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesApplicationStatsController',
  controllerAs: 'ctrl',
  bindings: {
    $transition$: '<',
  },
});
